const ChecktagResidents = ({ width = 16, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3589_4513)">
      <path
        opacity="0.28"
        d="M7.99957 14.666C11.6812 14.666 14.6658 11.6814 14.6658 7.99973C14.6658 4.31807 11.6812 1.3335 7.99957 1.3335C4.31792 1.3335 1.33334 4.31807 1.33334 7.99973C1.33334 11.6814 4.31792 14.666 7.99957 14.666Z"
        fill="#046C4E"
      />
      <path
        d="M14.5818 3.194L14.0044 3.58827C11.6692 5.18306 9.72653 7.28725 8.32275 9.7422L8.06093 10.2001L5.52942 7.27146M14.5566 6.78789C15.004 9.2176 14.0775 11.8021 11.955 13.3664C8.99135 15.5507 4.81808 14.9189 2.63378 11.9552C0.449482 8.9915 1.0813 4.81823 4.04499 2.63393C6.16744 1.06964 8.91026 0.949665 11.0986 2.09615"
        stroke="#046C4E"
        strokeWidth="1.09282"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3589_4513">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ChecktagResidents;
